var SizeUnit;
(function(SizeUnit) {
    SizeUnit["B"] = "B";
    SizeUnit["KB"] = "KB";
    SizeUnit["MB"] = "MB";
    SizeUnit["GB"] = "GB";
    SizeUnit["TB"] = "TB";
})(SizeUnit || (SizeUnit = {}));
const unitSizes = {
    ["B"]: 1,
    ["KB"]: 1024,
    ["MB"]: 1024 * 1024,
    ["GB"]: 1024 * 1024 * 1024,
    ["TB"]: 1024 * 1024 * 1024
};
function isLarger(unit1, unit2) {
    return unitSizes[unit1] > unitSizes[unit2];
}
function getUnit(sizeInB) {
    const sizeInKB = sizeInB / 1024;
    const sizeInMB = sizeInKB / 1024;
    const sizeInGB = sizeInMB / 1024;
    const sizeInTB = sizeInGB / 1024;
    if (sizeInTB > 1) {
        return "TB";
    } else if (sizeInGB >= 1) {
        return "GB";
    } else if (sizeInMB >= 1) {
        return "MB";
    } else if (sizeInKB >= 1) {
        return "KB";
    } else {
        return "B";
    }
}
function round(num) {
    if (!num) return num;
    const rounded = num.toFixed(2);
    return parseFloat(rounded);
}
function getSizeInUnits(sizeInB, unit) {
    switch(unit){
        case "B":
            return round(sizeInB);
        case "KB":
            return round(sizeInB / 1024);
        case "MB":
            return round(sizeInB / (1024 * 1024));
        case "GB":
            return round(sizeInB / (1024 * 1024 * 1024));
        case "TB":
            return round(sizeInB / (1024 * 1024 * 1024 * 1024));
        default:
            return round(sizeInB);
    }
}
export { SizeUnit, getUnit, getSizeInUnits, isLarger };
